import { mapActions } from "vuex";

export default{
    methods :{
        ...mapActions("loginmaster", ["sendLogin"]),
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == " ") {
                c = c.substring(1);
              }
      
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
          },
          goLand() {

            if(this.started){
                this.movedown();
            }
            if (this.$route.query.redirect) {
              this.$router.push(this.$route.query.redirect);
            } else {
              if (this.details.category == "Organization") {
                if (this.details.clearance_organization != "Quicktest") {
                  this.$router.push({
                    name: "orgdashboardhome"
                  });
                } else {
                  this.$router.push({
                    name: "adminhome"
                  });
                }
              }
            }
          },
          movedown() {
            let categoryName = JSON.parse(this.start_config.category).name;
            // console.log( JSON.parse(this.start_config.category).name)
            this.$router.push({
              name: "testhall",
              params: {
                trackid: this.start_config.track_id,
                category: categoryName,
                institution: this.start_config.institution_shortname
              }
            });
          },
    }
}